import type { MonthlyClosing } from '@shared/types';

/**
 * Firestore Timestamp / モックを問わずミリ秒に変換する。
 * 締め日時の比較（どのイベントが最新か）に使う。
 */
export function eventMillis(
  ts: { toMillis?: () => number; seconds?: number } | null | undefined
): number {
  if (!ts) return 0;
  if (typeof ts.toMillis === 'function') return ts.toMillis();
  if (typeof ts.seconds === 'number') return ts.seconds * 1000;
  return 0;
}

/**
 * 各月の「現在状態」を返す。現在状態 = その月で closedAt が最大のイベント。
 */
export function deriveCurrentStates(
  events: MonthlyClosing[]
): Map<string, MonthlyClosing> {
  const latest = new Map<string, MonthlyClosing>();
  for (const e of events) {
    const cur = latest.get(e.yearMonth);
    if (!cur || eventMillis(e.closedAt) > eventMillis(cur.closedAt)) {
      latest.set(e.yearMonth, e);
    }
  }
  return latest;
}

/** 現在「解除中（unlock）」のままになっている月の yearMonth 一覧。 */
export function findUnlockedMonths(events: MonthlyClosing[]): string[] {
  return [...deriveCurrentStates(events).values()]
    .filter((e) => e.action === 'unlock')
    .map((e) => e.yearMonth);
}

/** 各月の現在状態を表すイベントの id 集合（一覧で操作ボタンを出す行の判定に使う）。 */
export function currentEventIds(events: MonthlyClosing[]): Set<string> {
  return new Set([...deriveCurrentStates(events).values()].map((e) => e.id));
}
